import React from 'react'

import MicrocmsImage from '@atoms/MicrocmsImage'
import Link from '@atoms/Link'
import {
  ArticleLinkCardContent,
  LinkCardContent,
  isPreview,
  isValidString,
} from '@models/Article'

import * as style from './style.module.sass'

type LinkCardProps = (LinkCardContent | ArticleLinkCardContent) & {
  isArtisan?: boolean
}

const LinkCard: React.FC<LinkCardProps> = props => {
  if (props.fieldId === 'card') {
    return <ExternalLinkCard {...props} />
  }

  const { list, isArtisan } = props

  if (list === null) {
    if (!isPreview()) {
      throw Error('不正な内部リンクカードが指定されています')
    }

    return (
      <div className={style.nullCard}>
        <strong>内部リンクカード</strong>
        <br />
        参照している記事が下書きの状態です / Referenced article is a draft
      </div>
    )
  }

  const linkPath =
    list.parentPage === null
      ? `/${list.category}/${list.id}`
      : `/${list.category}/${list.parentPage.id}/${list.id}`

  return (
    <Link to={linkPath} className={style.linkCard} data-artisan={isArtisan}>
      <MicrocmsImage image={list.thumbnail} alt={list.title} type="thumbnail" />
      <div className={style.info}>
        <div className={style.title}>{list.title}</div>
      </div>
    </Link>
  )
}

const ExternalLinkCard: React.FC<LinkCardContent & { isArtisan?: boolean }> = ({
  url,
  title,
  image,
  contents,
  isArtisan,
}) => (
  <a
    href={url}
    className={style.linkCard}
    data-artisan={isArtisan}
    target="_blank"
    rel="noreferrer"
  >
    {image !== null && image !== undefined && (
      <MicrocmsImage image={image} alt={title} type="thumbnail" />
    )}
    <div className={style.info}>
      <div className={style.title}>{title}</div>
      {isValidString(contents) && (
        <p
          className={style.contents}
          dangerouslySetInnerHTML={{ __html: contents }}
        />
      )}
      <div className={style.url}>{url}</div>
    </div>
  </a>
)

export default LinkCard
